/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import { useAppSelector } from "../../../infra/hooks";
import DTOVerticalBar from "./DTOVerticalBar";
import VerticalBarPresenter from "./VerticalBarPresenter";
import { useTranslation } from "react-i18next";
interface PropsValue {
  instanceId: number;
}
function VerticalBarController({ instanceId }: PropsValue) {
  const [workflows, setWorkflows] = useState([]);
  const [pendingWithData, setPendingWithData] = useState([]);

  const { t } = useTranslation();
  
  const isLoading = useAppSelector(
    (state) => state.workflowLoaderSlice.Loading
  );
  function getWorkflowData(data: any) {
    setWorkflows(data);
  }

  function getPendingWithData(data: any) {
    setPendingWithData(data);
  }

  return (
    <>
      <DTOVerticalBar
        instanceId={instanceId}
        setPendingWith={getPendingWithData}
        setWorkflowData={getWorkflowData}
      />
      <VerticalBarPresenter
        allSteps={workflows}
        pendingWithData={pendingWithData}
        isLoading={isLoading}
        trans={t}
      />
    </>
  );
}

export default VerticalBarController;
